import {
    CLEAR_HISTORY,
    SEEK_BEGAN, SEEK_CELLS_BEGAN, SEEK_CELLS_COMPLETE, SEEK_CELLS_FAILED, SEEK_CELLS_SUCCESS, SEEK_COMPLETE,
    SEEK_FAILED,
    SEEK_SUCCESS, SET_CELLS, SET_FETCH_ID,
    UPDATE_BEGAN, UPDATE_CELLS_BEGAN, UPDATE_CELLS_FAILED, UPDATE_CELLS_SUCCESS,
    UPDATE_FAILED,
    UPDATE_SUCCESS
} from "../actionTypes/history";
import axios from "axios";
import * as API from "../../constants/api";
import {openBatteryIdSelector, openBatterySelector} from "../reducers/openReducer";
import {
    cellPageSelector,
    cellsSelector,
    fetchIdSelector,
    historyLengthSelector,
    pageSelector
} from "../reducers/historyReducer";
import moment from "moment";
import {preFilterLevel} from "../../constants/data";

const seekSize = 5000
// const firstSeekDeviser = 4
// const firstSeek = 5000
const milsInMin = 1000 * 60
const datetimeFormat = 'YYYY-MM-DD HH:mm'

export const updateHistory = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: UPDATE_BEGAN
        })


        try{

            let battId = openBatteryIdSelector(getState())

            let response = await axios.get(API.getStates(battId, 1, 1), {headers: API.defaultHeaders})

            dispatch({
                type: SET_CELLS,
                payload: response.data.battery.cells
            })

            let openBatt = openBatterySelector(getState())
            if(openBatt.Battery_id !== battId){return}
            let from = moment(openBatt.battery_createdAt, 'YYYY-MM-DD HH:mm')

            dispatch({
                type: UPDATE_SUCCESS,
                payload: response.data.battery.batteryStates.map(st => ({...st, minutesFrom: moment.duration(moment(st.createdAt, 'YYYY-MM-DD HH:mm').diff(from)).asMinutes()}))
            })
        }catch(error){
            dispatch({
                type: UPDATE_FAILED,
                payload: error
            })
        }
    }
}

export const seekHistory = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SEEK_BEGAN,
            payload: openBatteryIdSelector(getState())
        })

        let fetchId = Math.random()
        dispatch({
            type: SET_FETCH_ID,
            payload: fetchId
        })

        try{
            let complete = false
            do {
                let page = pageSelector(getState()) + 1
                let response = await axios.get(API.getStates(openBatteryIdSelector(getState()), page, seekSize), {headers: API.defaultHeaders})

                if(fetchIdSelector(getState()) !== fetchId){
                    return
                }


                let openBatt = openBatterySelector(getState())
                // let from = moment(openBatt.battery_createdAt, 'YYYY-MM-DD HH:mm')

                // let by = Number.parseInt(openBatt.battery_createdAt.substr(0, 4))
                // let bm = Number.parseInt(openBatt.battery_createdAt.substr(5, 2))-1
                // let bd = Number.parseInt(openBatt.battery_createdAt.substr(8, 2))
                // let bh = Number.parseInt(openBatt.battery_createdAt.substr(11, 2))
                // let bmi = Number.parseInt(openBatt.battery_createdAt.substr(4, 2))
                // let bdate = new Date(by, bm, bd, bh, bmi,0, 0)

                let newStates = response.data.battery.batteryStates
                let filteredStates = new Array(Math.floor(newStates.length/preFilterLevel))
                let c = 0

                for(let i = 0; i<newStates.length; i+=preFilterLevel){
                    // let y = Number.parseInt(newStates[i].createdAt.substr(0, 4))
                    // let m = Number.parseInt(newStates[i].createdAt.substr(5, 2))-1
                    // let d = Number.parseInt(newStates[i].createdAt.substr(8, 2))
                    // let h = Number.parseInt(newStates[i].createdAt.substr(11, 2))
                    // let mi = Number.parseInt(newStates[i].createdAt.substr(14, 2))
                    // // console.log(y,m,d,h,mi)
                    // let sdate = new Date(y, m, d, h, mi,0, 0)
                    //
                    // // let diff = sdate-bdate
                    filteredStates[c] = newStates[i]
                    // filteredStates[c].minutesFrom = Math.floor((sdate-bdate) / milsInMin)

                    c++
                    //newStates[i].minutesFrom = moment.duration(moment(sdate).diff(from)).asMinutes()
                    // newStates[i].minutesFrom =
                }

                dispatch({
                    type: SEEK_SUCCESS,
                    payload: {states: filteredStates, page}
                })

                complete = response.data.battery.batteryStates.length === 0

            }while(!complete)

            dispatch({
                type: SEEK_COMPLETE,
            })
        }catch(error){
            dispatch({
                type: SEEK_FAILED,
                payload: error
            })
        }
    }
}




export const updateCellHistory = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: UPDATE_CELLS_BEGAN
        })

        let openBatt = openBatterySelector(getState())
        let from = moment(openBatt.battery_createdAt, 'YYYY-MM-DD HH:mm')

        try{

            let cells = cellsSelector(getState())
            let states = []

            // for(let i = 0; i<cells.length; i++){
            //     let response = await axios.get(API.getCellStates(cells[i].id, 1, 1), {headers: API.defaultHeaders})
            //     states.push(...response.data.cell.cellStates)
            // }
            let callsBatt = null

            let promises = cells.map(async cell => {
                let response = await axios.get(API.getCellStates(cell.id, 1, 1, true), {headers: API.defaultHeaders})
                states.push({
                    cellId: cell.id,
                    states: response.data.cell.cellStates.map(st => ({...st, all: true}))
                })
                callsBatt = cell.Battery_id
            })
            await Promise.all(promises)
            // responses.forEach(response => states.push(...response.data.cell.cellStates))

            // console.log('Checking update relevance: ', openBatteryIdSelector(getState()), callsBatt, openBatteryIdSelector(getState()) !== callsBatt)
            if(openBatteryIdSelector(getState()) !== callsBatt){return}


            dispatch({
                type: UPDATE_CELLS_SUCCESS,
                payload: states
            })
        }catch(error){
            dispatch({
                type: UPDATE_CELLS_FAILED,
                payload: error
            })
        }
    }
}

export const seekCellHistory = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SEEK_CELLS_BEGAN,
            payload: openBatteryIdSelector(getState())
        })

        let fetchId = Math.random()
        dispatch({
            type: SET_FETCH_ID,
            payload: fetchId
        })

        try{
            let complete = false
            do {
                let page = cellPageSelector(getState()) + 1
                let cells = cellsSelector(getState())
                //let states = []
                let collected = 0

                // for(let i = 0; i<cells.length; i++){
                //     let response = await axios.get(API.getCellStates(cells[i].id, page, seekSize), {headers: API.defaultHeaders})
                //     states.push(...response.data.cell.cellStates)
                //
                //     if(fetchIdSelector(getState()) !== fetchId){
                //         return
                //     }
                // }

                let states = []

                let openBatt = openBatterySelector(getState())
                // let from = moment(openBatt.battery_createdAt, 'YYYY-MM-DD HH:mm')

                // let by = Number.parseInt(openBatt.battery_createdAt.substr(0, 4))
                // let bm = Number.parseInt(openBatt.battery_createdAt.substr(5, 2))-1
                // let bd = Number.parseInt(openBatt.battery_createdAt.substr(8, 2))
                // let bh = Number.parseInt(openBatt.battery_createdAt.substr(11, 2))
                // let bmi = Number.parseInt(openBatt.battery_createdAt.substr(4, 2))
                // let bdate = new Date(by, bm, bd, bh, bmi,0, 0)

                let promises = cells.map(async cell => {
                    let response = await axios.get(API.getCellStates(cell.id, page, seekSize, false), {headers: API.defaultHeaders})
                    if(fetchIdSelector(getState()) !== fetchId){
                        throw Error('CANCELLED')
                    }

                    // dispatch({
                    //     type: SEEK_CELLS_SUCCESS,
                    //     payload: {states: response.data.cell.cellStates.map(st => ({...st, minutesFrom: moment.duration(moment(st.createdAt, 'YYYY-MM-DD HH:mm').diff(from)).asMinutes()})), page}
                    // })
                    // states = [...states, ...response.data.cell.cellStates]

                    //states = states.concat(response.data.cell.cellStates)

                    states.push({
                        cellId: cell.id,
                        states: response.data.cell.cellStates //response.data.cell.cellStates.map(st => ({...st, minutesFrom: moment.duration(moment(st.createdAt, 'YYYY-MM-DD HH:mm').diff(from)).asMinutes()}))
                    })

                    collected += response.data.cell.cellStates.length
                })
                try {
                    await Promise.all(promises)
                }catch(error){
                    if(error.message === 'CANCELLED'){
                        return
                    }else{
                        throw error
                    }
                }
                states.forEach(stateGroup => {

                    let newStates = stateGroup.states

                    let filteredStates = new Array(Math.floor(newStates.length/preFilterLevel))
                    let c = 0

                    for(let i = 0; i<newStates.length; i+=preFilterLevel){
                        // let y = Number.parseInt(newStates[i].createdAt.substr(0, 4))
                        // let m = Number.parseInt(newStates[i].createdAt.substr(5, 2))-1
                        // let d = Number.parseInt(newStates[i].createdAt.substr(8, 2))
                        // let h = Number.parseInt(newStates[i].createdAt.substr(11, 2))
                        // let mi = Number.parseInt(newStates[i].createdAt.substr(14, 2))
                        // // console.log(y,m,d,h,mi)
                        // let sdate = new Date(y, m, d, h, mi,0, 0)

                        filteredStates[c] = newStates[i]
                        // filteredStates[c].minutesFrom = Math.floor((sdate-bdate) / milsInMin)

                        c++
                    }
                    // states.push({
                    //     cellId: cell.id,
                    //     states: filteredStates//response.data.cell.cellStates.map(st => ({...st, minutesFrom: moment.duration(moment(st.createdAt, 'YYYY-MM-DD HH:mm').diff(from)).asMinutes()}))
                    // })

                    stateGroup.states = newStates
                })

                dispatch({
                    type: SEEK_CELLS_SUCCESS,
                    payload: {states: states, page}
                })

                if(fetchIdSelector(getState()) !== fetchId){
                    return
                }
                //responses.forEach(response => states.push(...response.data.cell.cellStates))

                // dispatch({
                //     type: SEEK_CELLS_SUCCESS,
                //     payload: {states: states, page}
                // })

                complete = collected === 0

            }while(!complete)

            dispatch({
                type: SEEK_CELLS_COMPLETE,
            })

        }catch(error){
            dispatch({
                type: SEEK_CELLS_FAILED,
                payload: error
            })
        }
    }
}

export const clearHistory = () => {
    return {
        type: CLEAR_HISTORY,
    }
}